import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TdContainerBlockContentComponent } from "./td-container-block-content.component";
import { TdSeparatorModule } from "app_quotation/shared/components/table/block-content/td-separator/td-separator.module";
import { TdDayModule } from "libraries/component/table/td-day/td-day.module";
import { TdBlockTitleModule } from "./components/td-block-title/td-block-title.module";

@NgModule({
    imports: [
        CommonModule,
        TdSeparatorModule,
        TdDayModule,
        TdBlockTitleModule,
    ],
    exports: [
        TdContainerBlockContentComponent,
    ],
    declarations: [
        TdContainerBlockContentComponent,
    ],
})

export class TdContainerBlockContentModule {}
